import { syncHistoryWithStore } from 'react-router-redux';

const initRouterHistory = ({ store, history }) => {
  return syncHistoryWithStore(history, store);
};
export default initRouterHistory;
